import {
  getShowArticleBySlugQueryOptions,
  useShowArticleById,
  useShowArticleBySlug,
} from '@/hooks/api/article/use-article';

/**
 * The analysis modal's article query settings. The card warms the slug query
 * the moment it navigates to the modal, so the fetch runs in parallel with
 * the intercept's RSC round trip; with React Query's default `staleTime: 0`
 * the modal would refetch that entry as soon as it mounted.
 */
export const ARTICLE_ANALYSIS_QUERY = {
  staleTime: 5 * 60 * 1000,
  refetchOnWindowFocus: false,
} as const;

/** The slug query both the modal content and the card's warm-up use. */
export const articleAnalysisQueryOptions = (slug: string) =>
  getShowArticleBySlugQueryOptions({ slug }, { query: ARTICLE_ANALYSIS_QUERY });

/**
 * The article behind an analysis: by slug, or by id on a slug-less by-url
 * landing. The ONE query for it on a page: the modal's content and the
 * landing's hero card (its scores, `useArticleScores`) both read it, so a
 * landing fetches the article once.
 */
export const useArticleAnalysisQuery = (
  slug: string | null,
  articleId?: number,
) => {
  const bySlug = useShowArticleBySlug(
    { slug: slug ?? '' },
    { query: ARTICLE_ANALYSIS_QUERY },
  );
  const byId = useShowArticleById(
    { id: articleId ?? 0 },
    { query: { ...ARTICLE_ANALYSIS_QUERY, enabled: !slug && !!articleId } },
  );
  return slug ? bySlug : byId;
};
